module.exports = __webpack_public_path__ + "static/media/PM GATISHAKTI TAG-Agenda (1).d88d199f.svg";